export const ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  USER: "user",
};

export const isAdmin = (role) => role === ROLES.ADMIN || role === ROLES.SUPER_ADMIN;
export const isSuperAdmin = (role) => role === ROLES.SUPER_ADMIN;

/**
 * Whether a given role can access an admin panel path.
 * super_admin — full access to everything.
 * admin — products, orders, notifications, customer management; NOT team management.
 * user (or undefined) — no admin access at all.
 */
/**
 * Where a user should land after signing in.
 * Admins (admin + super_admin) → admin panel.
 * Everyone else → customer dashboard.
 */
export const getPostLoginPath = (role) => {
  return isAdmin(role) ? "/admin" : "/dashboard";
};

export const canAccessAdminPath = (path, role) => {
  if (role === ROLES.SUPER_ADMIN) return true;
  if (role === ROLES.ADMIN) return !path.startsWith("/admin/team");
  return false;
};